import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
	path: '/',
	redirect: '/LandingPage'
  },{
	  path: '/PinjamCepat',
	  name: 'PinjamCepat',
	  component: () => import('@/page/Pinjam/PinjamCepat')
  },{
	  path: '/LandingPage',
	  name: 'LandingPage',
	  component: () => import('@/page/Pinjam/LandingPage')
  }
]

const router = new VueRouter({
  routes
})

export default router